import Footers from './footers';
import Headers from './headers';

export default {
  Footers,
  Headers,
};
